import React from "react";

const ThirdPlace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.218"
    height="36.017"
    viewBox="0 0 27.218 36.017">
    <defs />
    <g id="Group_9214" transform="translate(-316.782 -488)">
      <path
        id="Path_15242"
        d="M2298.555 187.392l-9.742-4.16-9.741 4.16V162.7h19.483z"
        className="cls-3-mobile"
        transform="translate(-1958.072 336.625)"
      />
      <g id="Group_9148" transform="translate(-2569.29 -120.173)">
        <circle
          id="Ellipse_1723"
          cx="13.609"
          cy="13.609"
          r="13.609"
          fill="#b4988a"
          transform="translate(2886.072 608.173)"
        />
        <circle
          id="Ellipse_1724"
          cx="10.465"
          cy="10.465"
          r="10.465"
          className="cls-3-mobile"
          transform="translate(2889.216 611.316)"
        />
        <text
          id="_3"
          fill="#b4988a"
          fontFamily="Roboto-Black, Roboto"
          fontSize="14px"
          fontWeight="800"
          transform="translate(2896.171 626.47)">
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export default ThirdPlace;
